export default {
    "html" : require("./html").default,
    "css": require("./css").default,
    "cssMobile": require("./cssMobile").default,
    "scss": require("./scss").default,
    "scssMobile": require("./scssMobile").default
}